import '.l{display:flex;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.bn{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.bo{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.bp{margin-top:2rem;}.ssr-plugin'
import '.bq{margin-bottom:5rem;}.ssr-plugin'
import '.br{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="l aa a1 m bn"
      >
        <DashboardNavBar />
        <div className="bo l m az bp bq br"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
